module.exports = __webpack_public_path__ + "assets/pink-twitter.f4dd6bb2.svg";